module.exports = __webpack_public_path__ + "static/media/logo_casa_do_pequeno_cidadao.d6c86925.png";